import FontBody1 from '../../../../../../../components/fonts/font-body1/font-body1';
import FontHeading4 from '../../../../../../../components/fonts/font-heading4/font-heading4';
import { FONT_COLOR, FONT_VARIANT } from '../../../../../../../components/fonts/font-props';
import { decimalFormat } from '../../../../../../../services/helpers';

import CalculatorLineItem from '../calculator-line-item/calculator-line-item';

interface ICalculatorCategoryProps {
    title: string;
    amount?: number | string;
    tax?: number | string;
}

const CalculatorCategoryTitle: React.FC<ICalculatorCategoryProps> = ({ title = "", amount = "", tax = "" }) => {
    const formattedAmount = typeof amount === 'number' ? Number(decimalFormat(amount, 4)) : amount;
    const formattedTax = typeof tax === 'number' ? Number(decimalFormat(tax, 4)) : tax;

    return (
        <div className="refund-calculator__category-title">
            <CalculatorLineItem
                description={<FontHeading4 variant={FONT_VARIANT.BOLD}>{title}</FontHeading4>}
                price={<FontBody1 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>{formattedAmount}</FontBody1>}
                tax={<FontBody1 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>{formattedTax || "-"}</FontBody1>}
            />
        </div>
    );
};

export default CalculatorCategoryTitle;
